export const POST_JOB_FOR_CLIENT_FIELDS = {
  employer: "employer",
  hiring_manager: "hiring_manager",
  op_owners: "op_owners",
  sale_owners: "sale_owners",
  job_fill_support_type: "job_fill_support_type",
};
